$(document).ready(function() {
    $(document).on('click', '.js-preorder-bonus-button', function() {
        $('body').addClass('is-modal-open');
        $('.js-preorder-bonus').addClass('show');
    });
    $(document).on('click', '.js-preorder-bonus-close', function(e) {
        $('.js-preorder-bonus').removeClass('show');
        $('body').removeClass('is-modal-open');
    });
    $(document).on('click', '.js-preorder-bonus', function(e) {
        if (!((e.target).closest('.js-preorder-bonus-content'))) {
            $('.js-preorder-bonus').removeClass('show');
            $('body').removeClass('is-modal-open');
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/bonus.js